import { createContext, useContext } from 'react'

export type PlayMenuControls = {
  open: boolean
  openMenu: (
    trigger: HTMLElement,
    beforeNavigate?: () => boolean | void,
    returnToMenu?: () => boolean | void,
  ) => void
  closeMenu?: () => void
  beforeNavigate?: () => boolean | void
  returnToMenu?: () => boolean | void
}

export const PlayMenuContext = createContext<PlayMenuControls | null>(null)
export const usePlayMenu = () => useContext(PlayMenuContext)
